import { METHODS, requestV3 } from '../axiosInstances';

export default {
  options: ({ type = 'review' }) => requestV3(METHODS.GET, `${type}/options/`, {}),
};
